import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { useDocuments } from '~/react-query-hooks/documents/useDocumentsEntity';
import { DocumentViewer } from '~/views/alfred/document-search/document-viewer/DocumentViewer';

import * as S from './DocumentModal.styles';
import { useDocumentModal } from './useDocumentModal';

export const DocumentModal = () => {
  const { isOpen, activeDocumentId, closeModal } = useDocumentModal();
  const { data, isFetching, isError } = useDocuments([activeDocumentId ?? '']);
  const document = data?.[0];

  const getContent = () => {
    if (isFetching) {
      return (
        <S.StyledSkeletonLoaderWrapper>
          <SkeletonLoader areas={S.styledSkeletonLoaderAreas} />
        </S.StyledSkeletonLoaderWrapper>
      );
    }

    if (!document || isError) {
      return null;
    }

    return (
      <S.ContentWrapper>
        <DocumentViewer
          selectedCitation={{
            document_id: document.id,
            document_name: document.name,
            document_type: document.type,
            pages: [],
          }}
          highlightTexts={[]}
          showHeader={false}
        />
      </S.ContentWrapper>
    );
  };

  return (
    document && (
      <S.StyledModal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${document.name}.${document.type}`}
      >
        {getContent()}
      </S.StyledModal>
    )
  );
};
